import type { CustomDirectusTypes } from '@funnellab/shared/src/types/directus';
import type { CellComponent, ItemTypeFromQuery } from '../table/types';
import TrashButton from '../TrashButton';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type organizationTableQuery } from '@src/api/queries/organization';
import { deleteOrganization } from '@src/api/services/OrganizationService';
import { ErrorToast } from '../modals/ErrorToast';

export const RowActions: CellComponent<
  ItemTypeFromQuery<
    CustomDirectusTypes,
    'organization',
    typeof organizationTableQuery
  >,
  { reload: () => void }
> = ({ rowData, reload }) => {
  const [error, setError] = useState<string | null>(null);

  const { t } = useTranslation('view', { keyPrefix: 'organizationList' });
  const deleteOrg = useCallback(async () => {
    try {
      await deleteOrganization(rowData.id);
      reload();
    } catch {
      setError(t('delete.error', { name: rowData.name }));
    }
  }, [reload, rowData.id, rowData.name, t]);

  return (
    <div className="-my-4 flex gap-1">
      <TrashButton
        className="!inline-block !bg-white !rounded-xl !p-3 !w-[2.625rem] !h-[2.625rem] border-blue-100 border"
        onClick={(event) => {
          event.preventDefault();
          void deleteOrg();
        }}
        showConfirmation
        confirmationMessage={t('delete.confirmation', { name: rowData.name })}
        testId={`delete-org-${rowData.id}`}
        tooltip={t('delete.tooltip')}
      />
      {error && <ErrorToast message={error} onClose={() => setError(null)} />}
    </div>
  );
};
